import { IrregularidadeCadastral } from "src/app/sitfis/components/irregularidade-cadastral/model/irregularidade-cadastral";
import { SituacaoCadastral } from "src/app/sitfis/model/enum/situacao-cadastral";
import { TipoNI } from "src/app/sitfis/model/enum/tipo-ni";

export const IRREGULARIDADE_CADASTRAL: IrregularidadeCadastral[] = [
  {
    "situacaoCadastral": SituacaoCadastral.SOCIO_IRREGULAR,
    "descricao": "Integrante do QSA com situação cadastral irregular",
    "tipoNi": TipoNI.CNPJ,
    "ni": "02036483000614",
    "listaCnae": [],
    "codigoSituacaoCadastro": 0,
    "descricaoSituacaoCadastro": null
  }
]